import { createApp } from 'vue';
import SetupImages from '@organisms/offer/SetupImages.vue';

export const setupImages = () => createApp({
  components: { SetupImages },
}).mount('.create-offer--step-images');
